import {
  COLORS,
  SPACING,
  SkeletonBlock,
  mobileOnlyLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CoinsLatestAchievementsSkeleton: React.FC = () => {
  return (
    <Wrapper>
      {Array.from({length: 5}).map((_, index) => (
        <CoinsMissionSkeletonWrapper key={index}>
          <SkeletonBlock $width="64px" $height="64px" disableSpaceBelow />
          <div>
            <SkeletonBlock $width="100%" $height="18px" disableSpaceBelow />
            <SkeletonBlock $width="124px" $height="8px" disableSpaceBelow />
            <SkeletonBlock $width="100px" $height="8px" disableSpaceBelow />
          </div>
          <SkeletonBlock $width="16px" $height="16px" disableSpaceBelow />
        </CoinsMissionSkeletonWrapper>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  ${mobileOnlyLinaria(`
    margin: ${SPACING['Y.Lg']} ${SPACING['X.Lg']};
  `)}
`;

const CoinsMissionSkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${SPACING['Y.Lg']} 0;
  gap: ${SPACING['X.Md']};

  > :nth-child(2) {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  > :last-child {
    border-radius: 16px;
  }

  & + & {
    border-top: 1px solid ${COLORS['Outline.Grey']};
  }
`;
